import React from 'react';
import './home.css';

const HomePage = () => (
	<div className="Homepage">
		<img
			src="https://cef-interstat.eu/wp-content/uploads/2020/12/INTERSTAT_Symbol.png"
			//className="App-logo"
			alt="logo"
		/>
		<p>INTERSTAT Support for Environment Policies pilot application</p>
		<a
			className="Framework-link"
			href="https://framework.cef-interstat.eu/"
			target="_blank"
			rel="noopener noreferrer"
		>
			INTERSTAT Framework homepage
		</a>

		<div className="Description">
		<br/>
		<br/>
		<br/>
		The SEP service combines <b>air pollution</b> and <b>demographic data</b> related to Italian and French territories. 
		<br/>In order to test cross-border interoperability, the SEP service could be used to compare air pollution indicators in selected Italian and French areas, 
		<br/>such as big cities, particularly Rome and Paris. Concerning cross-domain interoperability, the SEP service could link air quality indicators collected in 
		<br/>different stations of each municipality, with the age structure of resident population, to foster the adoption of policies to promote eco-friendly means 
		<br/>of transportations. The data sources investigated for the SEP are:

		<div class="SubDescription">
		<br/>		● <b>Italian Census data</b>: data of the Census of Population and Housing aggregated at different territorial levels produced by ISTAT
		<br/>		● <b>French Census data</b>: data of the Census of Population and Housing aggregated at different territorial levels produced by Insee
		<br/>		● <b>French air pollution data</b> published by the European Environment Agency (EEA)
		<br/>		● <b>Italian air pollution data</b> published by the Italian Institute for Environmental Protection and Research (ISPRA)
		</div>
		<br/>To harmonize and integrate the information provided by available data sources, a common representation of the main concepts through 
		<br/>the specification of a common ontology was essential.
		</div>

	</div>
);

export default HomePage;
